/**
 * 模块: 趋势分析图表组件
 * 职责: 展示多个Tab页的图表内容
 * 限制: 文件<280行
 */

import React from 'react';
import { Card, Tabs, Radio, Space, Empty } from 'antd';
import { TrendChart } from '../../components/TrendChart';
import BrandNetworkGraph from '../../components/BrandNetworkGraph';
import ASINTrajectory from '../../components/ASINTrajectory';
import BrandMarketShift from '../../components/BrandMarketShift';

interface TrendChartsProps {
  loading: boolean;
  trendData: any[];
  selectedMetrics: string[];
  chartType: 'line' | 'bar' | 'area';
  networkData: { nodes: any[]; edges: any[]; stats?: { own_brand?: string } };
  trajectoryData: any[];
  marketShiftData: any[];
  onChartTypeChange: (type: 'line' | 'bar' | 'area') => void;
}

export const TrendCharts: React.FC<TrendChartsProps> = ({
  loading,
  trendData,
  selectedMetrics,
  chartType,
  networkData,
  trajectoryData,
  marketShiftData,
  onChartTypeChange,
}) => {
  const tabItems = [
    {
      key: 'trends',
      label: '关键词趋势',
      children: (
        <Card className="chart-card" loading={loading}>
          <div className="chart-controls">
            <Space>
              <span>图表类型：</span>
              <Radio.Group value={chartType} onChange={(e) => onChartTypeChange(e.target.value)}>
                <Radio.Button value="line">折线图</Radio.Button>
                <Radio.Button value="bar">柱状图</Radio.Button>
                <Radio.Button value="area">面积图</Radio.Button>
              </Radio.Group>
            </Space>
          </div>

          {trendData.length > 0 ? (
            <TrendChart 
              data={trendData} 
              metrics={selectedMetrics} 
              chartType={chartType} 
              showComparison={true} 
            />
          ) : (
            <Empty description="请选择周期和指标以查看趋势" style={{ margin: '60px 0' }} />
          )}
        </Card>
      ),
    },
    {
      key: 'network',
      label: '品牌网络图',
      children: (
        <Card className="chart-card">
          {networkData.nodes.length ? (
            <BrandNetworkGraph 
              nodes={networkData.nodes} 
              edges={networkData.edges} 
              ownBrand={networkData.stats?.own_brand || ''} 
            />
          ) : (
            <Empty description="暂无品牌竞争数据" style={{ margin: '60px 0' }} />
          )}
        </Card>
      ),
    },
    {
      key: 'asin',
      label: 'ASIN轨迹',
      children: (
        <Card className="chart-card">
          {trajectoryData.length ? (
            <ASINTrajectory data={trajectoryData} />
          ) : (
            <Empty description="请选择关键词以查看ASIN轨迹" style={{ margin: '60px 0' }} />
          )}
        </Card>
      ),
    },
    {
      key: 'shift',
      label: '市场抢占',
      children: (
        <Card className="chart-card">
          {marketShiftData.length ? (
            <BrandMarketShift data={marketShiftData} />
          ) : (
            <Empty description="暂无市场抢占数据" style={{ margin: '60px 0' }} />
          )}
        </Card>
      ),
    },
  ];

  return <Tabs defaultActiveKey="trends" items={tabItems} />;
};

